/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BigCommerceProductRef } from "./BigCommerceProductRef";
import {
  BigCommerceProductRefFromJSON,
  BigCommerceProductRefFromJSONTyped,
  BigCommerceProductRefToJSON,
  BigCommerceProductRefToJSONTyped,
} from "./BigCommerceProductRef";

/**
 * Products matching a search, for picking the ones a store never ships as freight.
 * @export
 * @interface BigCommerceProductSearchResponse
 */
export interface BigCommerceProductSearchResponse {
  /**
   *
   * @type {Array<BigCommerceProductRef>}
   * @memberof BigCommerceProductSearchResponse
   */
  products: Array<BigCommerceProductRef>;
  /**
   *
   * @type {string}
   * @memberof BigCommerceProductSearchResponse
   */
  problem?: string | null;
}

/**
 * Check if a given object implements the BigCommerceProductSearchResponse interface.
 */
export function instanceOfBigCommerceProductSearchResponse(
  value: object,
): value is BigCommerceProductSearchResponse {
  if (!("products" in value) || value["products"] === undefined) return false;
  return true;
}

export function BigCommerceProductSearchResponseFromJSON(
  json: any,
): BigCommerceProductSearchResponse {
  return BigCommerceProductSearchResponseFromJSONTyped(json, false);
}

export function BigCommerceProductSearchResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceProductSearchResponse {
  if (json == null) {
    return json;
  }
  return {
    products: (json["products"] as Array<any>).map(
      BigCommerceProductRefFromJSON,
    ),
    problem: json["problem"] == null ? undefined : json["problem"],
  };
}

export function BigCommerceProductSearchResponseToJSON(
  json: any,
): BigCommerceProductSearchResponse {
  return BigCommerceProductSearchResponseToJSONTyped(json, false);
}

export function BigCommerceProductSearchResponseToJSONTyped(
  value?: BigCommerceProductSearchResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    products: (value["products"] as Array<any>).map(
      BigCommerceProductRefToJSON,
    ),
    problem: value["problem"],
  };
}
